/**
 * Grip Upgrade Add-to-Cart (pill/swatch version)
 * -------------------------------------------------
 * Pairs with the pill-button grip-upgrade HTML (image swatches instead of
 * a dropdown) in your Custom Liquid block.
 *
 * Behavior: clicking a pill selects that grip (only one selected at a
 * time). Clicking the theme's native "Add to Cart" button bundles the
 * club + selected grip into one request, tagging both line items so
 * fulfillment knows which grip goes with which club. If "No grip
 * upgrade" is selected, the native button behaves exactly as it always
 * has -- untouched.
 *
 * INSTALL: Re-upload this file as assets/grip-upgrade.js, replacing the
 * previous version.
 */
(function () {
  'use strict';

  function refreshCartDrawer() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return Promise.resolve();

    var sectionWrapper = cartDrawerEl.closest('[id^="shopify-section-"]');
    if (!sectionWrapper) return Promise.resolve();

    var sectionId = sectionWrapper.id.replace('shopify-section-', '');

    return fetch('/?sections=' + encodeURIComponent(sectionId))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (html) {
          sectionWrapper.innerHTML = html;
        }
      })
      .catch(function () {
        // If this fails for any reason, we just fall through and open
        // the drawer with whatever content it already has.
      });
  }

  /**
   * If a customer removes a grip from the cart, the club's "Grip Selected"
   * line item property doesn't update on its own -- Shopify has no native
   * concept of linked line items. This checks every club line that has a
   * "Grip Selected" property (tagged with a matching hidden _grip_pair_id)
   * and, if its paired grip is no longer in the cart, strips that property
   * off the club line via the Cart API.
   */
  var isReconciling = false;

  function reconcileGripProperties() {
    if (isReconciling) return Promise.resolve();

    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var updates = [];

        items.forEach(function (item, index) {
          var props = item.properties || {};
          var pairId = props['_grip_pair_id'];
          var gripLabel = props['Grip Selected'];
          if (!pairId || !gripLabel) return; // not a club line we tagged

          var stillHasGrip = items.some(function (other) {
            if (other === item) return false;
            var otherProps = other.properties || {};
            return otherProps['_grip_pair_id'] === pairId && !!otherProps['For Club'];
          });

          if (!stillHasGrip) {
            var newProps = {};
            Object.keys(props).forEach(function (key) {
              if (key !== 'Grip Selected') newProps[key] = props[key];
            });
            updates.push({ line: index + 1, quantity: item.quantity, properties: newProps });
          }
        });

        if (updates.length === 0) return null;

        isReconciling = true;

        return updates.reduce(function (chain, update) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(update)
            });
          });
        }, Promise.resolve()).then(function () {
          isReconciling = false;
          if (window.location.pathname.indexOf('/cart') === 0) {
            window.location.reload();
          } else {
            return refreshCartDrawer();
          }
        });
      })
      .catch(function () {
        isReconciling = false;
      });
  }

  // Watch every fetch the page makes; if it's a cart-changing request
  // (removals, quantity changes, etc, however the theme performs them),
  // reconcile the grip properties shortly afterward once the cart has
  // settled into its new state.
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var isCartChangeRequest = /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url);

    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartChangeRequest && !isReconciling && response.ok) {
        setTimeout(reconcileGripProperties, 150);
      }
      return response;
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.indexOf('/cart') === 0) {
      reconcileGripProperties();
    }
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getMainProductPrice() {
    var priceEl = document.querySelector('.f-price-item--regular, [data-product-price], .price__current, .product__price');
    if (!priceEl) return null;
    var match = priceEl.textContent.replace(/[^0-9.]/g, '');
    var value = parseFloat(match);
    return isNaN(value) ? null : Math.round(value * 100);
  }

  function initGripPills(wrapper) {
    var pills = wrapper.querySelectorAll('[data-grip-option]');
    var runningTotal = wrapper.querySelector('[data-grip-running-total]');

    function updateRunningTotal() {
      var gripPrice = parseInt(wrapper.getAttribute('data-selected-grip-price'), 10) || 0;
      var gripQty = parseInt(wrapper.getAttribute('data-grip-quantity'), 10) || 1;
      var totalGripCost = gripPrice * gripQty;

      if (totalGripCost === 0) {
        runningTotal.textContent = '';
        return;
      }

      var basePrice = getMainProductPrice();
      if (basePrice !== null) {
        runningTotal.innerHTML = 'New total: <span class="grip-upgrade__running-total-price">' + formatMoney(basePrice + totalGripCost) + '</span>';
      } else {
        runningTotal.innerHTML = 'Grip upgrade: +<span class="grip-upgrade__running-total-price">' + formatMoney(totalGripCost) + '</span>';
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('is-selected');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-checked', 'true');

        wrapper.setAttribute('data-selected-grip-id', pill.getAttribute('data-variant-id') || '');
        wrapper.setAttribute('data-selected-grip-title', pill.getAttribute('data-title') || '');
        wrapper.setAttribute('data-selected-grip-price', pill.getAttribute('data-price') || '0');

        updateRunningTotal();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-grip-upgrade]').forEach(initGripPills);
  });

  // Capture-phase intercept: fires before the form's own submit handler.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form.main-product-form')) return;

    var wrapper = document.querySelector('[data-grip-upgrade]');
    if (!wrapper) return;

    var gripVariantId = wrapper.getAttribute('data-selected-grip-id') || '';
    if (!gripVariantId) return; // "No grip upgrade" selected, let native flow run untouched

    e.preventDefault();
    e.stopImmediatePropagation();

    var status = wrapper.querySelector('[data-grip-status]');
    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var mainVariantId = idField ? idField.value : null;
    var quantity = qtyField ? (parseInt(qtyField.value, 10) || 1) : 1;

    if (!mainVariantId) {
      if (status) {
        status.textContent = 'Please select club options first.';
        status.setAttribute('data-state', 'error');
      }
      return;
    }

    var clubTitle = wrapper.getAttribute('data-main-product-title') || 'Club';
    var gripTitle = wrapper.getAttribute('data-selected-grip-title') || 'Grip';
    var gripQuantity = parseInt(wrapper.getAttribute('data-grip-quantity'), 10) || 1;
    var totalGripQuantity = gripQuantity * quantity;

    var clubSku = '';
    var skuMapRaw = wrapper.getAttribute('data-variant-skus') || '';
    skuMapRaw.split('|').some(function (pair) {
      var parts = pair.split(':');
      if (parts[0] === mainVariantId) {
        clubSku = parts[1] || '';
        return true;
      }
      return false;
    });

    var forClubLabel = clubSku ? ('SKU ' + clubSku) : clubTitle;
    var pairId = 'p_' + Date.now() + '_' + Math.floor(Math.random() * 1000000);

    var items = [
      {
        id: parseInt(mainVariantId, 10),
        quantity: quantity,
        properties: { 'Grip Selected': gripTitle, '_grip_pair_id': pairId }
      },
      {
        id: parseInt(gripVariantId, 10),
        quantity: totalGripQuantity,
        properties: { 'For Club': forClubLabel, '_grip_pair_id': pairId }
      }
    ];

    var submitButton = form.querySelector('.product-form__submit, [type="submit"][name="add"]');
    if (submitButton) submitButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) { throw err; });
        }
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        return refreshCartDrawer();
      })
      .then(function () {
        var cartTrigger = document.querySelector('[aria-controls="CartDrawer"]');
        if (cartTrigger) {
          cartTrigger.click();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        if (status) {
          status.textContent = (err && err.description) || 'Something went wrong. Please try again.';
          status.setAttribute('data-state', 'error');
        }
        if (submitButton) submitButton.disabled = false;
      });
  }, true); // <-- capture phase, this is the important part
})();